<div class="tree-table-container">
  <table class="tree-table">
    <thead>
      <tr>
        <th *ngFor="let column of columns" [style.width]="column.width">
          {{ column.header }}
        </th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let row of data">
        <!-- Parent Row -->
        <tr class="tree-table-row" [class.expanded]="row.expanded" (click)="onRowClick(row)">
          <td *ngFor="let column of columns" [style.padding-left]="column === columns[0] ? getIndentStyle(level) : '0'">
            <div class="cell-content">
              <span *ngIf="column === columns[0] && row.children?.length" 
                    class="expand-icon" 
                    (click)="toggleRow(row); $event.stopPropagation()">
                {{ row.expanded ? '▼' : '▶' }}
              </span>
              {{ row.data[column.field] }}
            </div>
          </td>
        </tr>
        
        <!-- Child Rows -->
        <tr *ngIf="row.expanded && row.children?.length">
          <td [attr.colspan]="columns.length" class="nested-table-cell">
            <app-score-drilldown-table-new
              *ngFor="let child of row.children"
              [columns]="columns"
              [data]="[child]"
              [level]="level + 1"
              (rowClick)="onRowClick($event)">
            </app-score-drilldown-table-new>
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>
</div>
